export class IntercomUtil {
  private static timer: NodeJS.Timer | null = null;
  private static numHides: number = 0;

  /**
   * Call this ONLY once per component (preferable in componentDidMount) to hide the Intercom widget.
   * We use a counter to track how many times it's been called and only actually show
   * the component again once the number of hides is zero.
   */
  public static hide(): void {
    this.numHides += 1;

    const myWindow = window as any;
    if (myWindow.Intercom) {
      // attempt to hide intercom and if it fails keep trying until it's found.
      //  (mainly here for full page reloads and other Intercom shenanigans)
      if (!this._hide() && !this.timer) {
        this.timer = setInterval(() => {
          // clear interval once it's hidden
          if (this._hide()) {
            clearInterval(this.timer!);
          }
        }, 500);
      }
    }
  }

  /**
   * Call this ONLY once per component (preferable in componentWillUnmount) to show the Intercom widget.
   * We use a counter to track how many times it's been called and only actually show
   * the component again once the number of hides is zero.
   */
  public static show(): void {
    this.numHides -= 1;

    if (this.numHides === 0) {
      // show intercom
      clearInterval(this.timer!);
      this._show();
    }
  }

  private static _hide(): boolean {
    return this._display("none");
  }

  private static _show(): boolean {
    return this._display("block");
  }

  private static _display(displayValue: string): boolean {
    // hide intercom
    const intercom = document.getElementById("intercom-container");
    if (intercom) {
      intercom.style.display = displayValue;
      return true;
    }
    return false;
  }
}
